import s from "./lastSlide.module.css";
import {useLastSlide} from "./useLastSlide";
import {
    productCartIcon,
    SSMFourthSlideStaticUnityPreview,
    SSMFourthSlideUnityPreview,
    SSMFourthSlideUnityPreviewVideo,
    SSMPlayIcon
} from "../../../../assets";
import ProgressBar from "../ProgressBar";
import {Fragment} from "preact";
import {Link} from "preact-router";
import {redirectLinkParser} from "../../../../utils";

const LastSlide = (props) => {
    // Destructured props
    const {
        selfServiceAttendanceModalData,
        currentSlide,
        handleCurrentSlide,
        TOTAL_SLIDES,
        handleClose
    } = props;

    // Component logic data
    const componentProps = useLastSlide();

    // Destructured component logic data
    const {} = componentProps;

    // Dynamic button for when a redirect link exists
    const button =
        !selfServiceAttendanceModalData?.redirect_link ?
            (
                <button
                    type={"button"}
                    className={`${s.continueShopping}`}
                    onClick={() => handleClose()}
                >
                    <img
                        src={productCartIcon}
                        alt="Cart icon"
                    />
                    Continuar comprando
                </button>
            ) : (
                <Link href={`/${redirectLinkParser(selfServiceAttendanceModalData.redirect_link)}`}>
                    <button
                        type={"button"}
                        className={`${s.continueShopping}`}
                        onClick={() => handleClose()}
                    >
                        <img
                            src={productCartIcon}
                            alt="Cart icon"
                        />
                        Continuar comprando
                    </button>
                </Link>
            );

    return (
        <div className={`w-full h-full ${s.root}`}>
            <div className={`absolute w-full h-full left-0 top-0 container-fluid`}>
                <div
                    className={`sabin-container h-full flex flex-col items-start justify-end lg:justify-center !pb-24 lg:!pb-0 gap-y-24 relative z-0`}>
                    <div className={`flex flex-col gap-y-6 ${s.textBlock}`}>
                        <h1 className={`${s.heading}`}>
                            {selfServiceAttendanceModalData?.stepFiveTitle || `Realize sua coleta com rapidez e tranquilidade.`}
                        </h1>
                        <div className={`relative z-0`}>
                            <p className={`${s.paragraph}`}>
                                {selfServiceAttendanceModalData?.stepFiveTextOne || (
                                    <Fragment>
                                        <strong>
                                            Viu como é simples?
                                        </strong>
                                        <br />
                                        Agora é só tomar seu café
                                        <br />
                                        e seguir com o seu dia!
                                    </Fragment>
                                )}
                            </p>
                        </div>
                        {button}
                    </div>
                </div>
            </div>
            <div className={`container-fluid w-full h-full`}>
                <div
                    className={`sabin-container h-full pointer-events-none relative transition-all duration-150`}>
                    <ProgressBar
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                        centered={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default LastSlide;
